module.exports = __webpack_public_path__ + "static/media/73.8f5b61e2.png";